
export const mediaQuotes = [
  {
    quote: "A two-hour romp through Brooklyn Heights that covers New York City history from a feline's perspective.",
    source: "The Guardian",
    publication: "The Guardian",
    context: "Brooklyn Heights tour coverage"
  },
  {
    quote: "NYC's first walking tour for cat lovers.",
    source: "amNY",
    publication: "amNY",
    context: "Unique cat-centric walking tours feature"
  },
  {
    quote: "No one else is doing this.",
    source: "People Magazine",
    publication: "People",
    context: "Unique cat-centric walking tours feature"
  }
];

export const pressHighlights = [
  {
    publication: "People Magazine",
    headline: "No One Else Is Doing This!",
    description: "Feature on unique cat-centric walking tours led by Peggy Gavan and Dan Rimada",
    date: "2024"
  },
  {
    publication: "The Guardian",
    headline: "Brooklyn Heights Cat Tour Coverage",
    description: "Coverage of the Brooklyn Heights tour featuring Jerry Fox and Ned the bridge-crossing cat",
    date: "2024"
  },
  {
    publication: "amNY",
    headline: "NYC's First Walking Tour for Cat Lovers",
    description: "Highlighted Jerry Fox saving Borough Hall and guest experiences",
    date: "2024"
  },
  {
    publication: "NBC New York",
    headline: "New NYC Walking Tour Aims to Capture Cat Lovers and History Buffs",
    description: "Television coverage of the unique cat history tours",
    date: "2024"
  }
];

export const companyFacts = [
  { label: "Founded", value: "August 2023" },
  { label: "Founders", value: "Peggy Gavan (historian), Dan Rimada (producer)" },
  { label: "Tours Operating", value: "Brooklyn Heights, Financial District & Lower East Side" },
  { label: "Duration", value: "Approximately 2 hours, covering 1.5 miles" },
  { label: "Tour Guides", value: "Team of three licensed NYC guides" },
  { label: "Content Curator", value: "All tours curated and researched by Peggy Gavan" },
  { label: "Media Hits", value: "People, The Guardian, amNY, NBC New York" },
  { label: "Contact", value: "catsabouttowntours@gmail.com" }
];

export const faqs = [
  {
    question: "What makes Cats About Town Tours unique?",
    answer: "We're the only walking tour company in NYC focused entirely on real cats who shaped the city's history—led by licensed guides and based on original archival research."
  },
  {
    question: "Who leads the tours?",
    answer: "All tours are led by one of our three licensed NYC guides. Every route is curated and researched by historian Peggy Gavan."
  },
  {
    question: "How long are the tours?",
    answer: "Each tour lasts about 2 hours and covers approximately 1.5 miles of walking."
  },
  {
    question: "Are the cat stories real?",
    answer: "Yes—all stories are based on documented sources including newspapers, archives, and city records."
  },
  {
    question: "Can media attend for coverage?",
    answer: "Absolutely. Email us to request a press ticket or schedule an interview."
  }
];
